import fetcher from 'api/fetcher';
import { NotificationName } from 'utils/constants/notification';

import { Act, setActs, setLoadActs, setSortActs } from 'store/models/acts';
import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const duplicateAct = (actId: number): AppThunkAction => {
    return async (dispatch, getState) => {
        const state = getState();
        const acts = state.acts.acts;

        return fetcher
            .post<unknown, Act>(`/api/v1/acts/${actId}/duplicate`)
            .then((act) => {
                const actIndex = acts.findIndex((a) => a.actId === act.actId);
                const newActs = [...acts];
                newActs.splice(actIndex + 2, 0, act);
                dispatch([setActs(newActs), setSortActs(new Map()), setLoadActs(false)]);
            })
            .catch((error) => {
                dispatch(addNotification(NotificationName.DuplicateActError));
                console.error('Duplicate Act', JSON.stringify(error));
            });
    };
};

export default duplicateAct;
